var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneGroupPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 9.00009H17C17.2652 9.00009 17.5196 9.10545 17.7071 9.29298C17.8946 9.48052 18 9.73487 18 10.0001V20.0001C18 20.2653 17.8946 20.5197 17.7071 20.7072C17.5196 20.8947 17.2652 21.0001 17 21.0001H1C0.734784 21.0001 0.48043 20.8947 0.292893 20.7072C0.105357 20.5197 0 20.2653 0 20.0001V10.0001C0 9.73487 0.105357 9.48052 0.292893 9.29298C0.48043 9.10545 0.734784 9.00009 1 9.00009H2V8.00009C1.99943 6.42279 2.53158 4.89153 3.51019 3.65452C4.4888 2.41752 5.8565 1.54727 7.3916 1.18485C8.92669 0.822435 10.5392 0.989089 11.9677 1.6578C13.3963 2.32651 14.5571 3.45809 15.262 4.86909L13.473 5.76309C12.9695 4.75511 12.1403 3.94674 11.1198 3.46904C10.0994 2.99134 8.94746 2.87232 7.85088 3.13127C6.7543 3.39022 5.77733 4.01196 5.07836 4.8957C4.37939 5.77943 3.9994 6.87335 4 8.00009V9.00009ZM7 14.0001V16.0001H11V14.0001H7Z",
    fill: "#32CD32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneGroupPoint);
export default __webpack_public_path__ + "static/media/done-group-point.54e5da51de93e01c37f567de49b67100.svg";
export { ForwardRef as ReactComponent };